import { render, staticRenderFns } from "./select-property-unit.vue?vue&type=template&id=27b94652&"
import script from "./select-property-unit.vue?vue&type=script&lang=js&"
export * from "./select-property-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "select-property-unit.vue"
export default component.exports